export default "__VITE_ASSET__DtLYzCV6__"